import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'bh_movie_favorites';

const readFavorites = (): number[] => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((x) => typeof x === 'number') : [];
  } catch {
    return [];
  }
};

export function useFavorites() {
  const [favorites, setFavorites] = useState<number[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());
  }, []);

  const persist = (next: number[]) => {
    setFavorites(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // ignore storage errors
    }
  };

  const toggleFavorite = useCallback(
    (id: number): boolean => {
      const current = readFavorites();
      const exists = current.includes(id);
      const next = exists ? current.filter((x) => x !== id) : [...current, id];
      persist(next);
      return !exists;
    },
    [],
  );

  const isFavorite = useCallback((id: number) => favorites.includes(id), [favorites]);

  return { favorites, toggleFavorite, isFavorite };
}